<script setup lang="ts">
import { ref, defineEmits, watch, onMounted } from 'vue';
import Alert from "@/components/ui/alerts/Alert.vue";
import Select, { Option } from '../ui/select/Select.vue';
import adminAPI from '@/services/api';

const emits = defineEmits<{
  (e: 'update:modelValue', selected: typeof officesOptions.value[number]): void
}>();

const officesOptions = ref<Array<Option>>([{ label: "Hors GDS", value: null }]);
onMounted(async () => {
  const offices = await adminAPI.listGdsOffices()
  officesOptions.value = offices.map(office =>
    ({
      label: isPassive(office.amadeusOfficeId) ? office.name || office.amadeusOfficeId : `${office.name} (${office.amadeusOfficeId})`,
      value: office.amadeusOfficeId,
      amadeusOfficeId: office.amadeusOfficeId,
    })
  );
  const passiveOfficeIndex = officesOptions.value.findIndex(office => isPassive((office as any).amadeusOfficeId));
  const moveToFirstIndex = (arr, currentIndex) => {
    const [element] = arr.splice(currentIndex, 1);
    arr.unshift(element);
  }
  moveToFirstIndex(officesOptions.value, passiveOfficeIndex);
  selected.value = officesOptions.value[0]
});


const selected = ref(officesOptions.value[0]);
watch(selected, () => emits("update:modelValue", selected.value.value));

const isPassive = (amadeusOfficeId) => Boolean(!amadeusOfficeId || amadeusOfficeId.includes('PASSIVE_OFFICE'))
</script>

<template>
  <div class="relative my-2">
    <Select
      label="Office"
      :options="officesOptions"
      :selected-option="0"
      @update:model-value="(newSelected: any) => selected = newSelected"
      :block="true"
    />

    <div v-if="!isPassive(selected?.value)" class="mt-6">
      <Alert
        type="info"
        title="Information"
        message="Pour les réservations GDS, merci de vouloir utiliser la fonctionnalité « Synchroniser le PNR »."
        :with-border="false"
      />
    </div>
  </div>
</template>
